$(document).ready ->
  csrf_token = $("meta[name=csrf-token]").attr("content")
  csrf_param = $("meta[name=csrf-param]").attr("content")
  params = undefined
  params = csrf_param + "=" + encodeURIComponent(csrf_token)  if csrf_param isnt `undefined` and csrf_token isnt `undefined`

  window.RedactorPlugins.supersub =
    init: ->
      this.buttonAdd('superscript', 'Superscript', this.executeSuperscript)
      this.buttonAwesome('superscript', 'icon-superscript')

      this.buttonAdd('subscript',   'Subscript',   this.executeSubscript)
      this.buttonAwesome('subscript', 'icon-subscript')

    executeSuperscript: ->
      this.execCommand('superscript')

    executeSubscript: ->
      this.execCommand('subscript')

  $(".redactor").redactor
    buttons: [
      "bold"
      "italic"
      "underline"
      "|"
      "link"
    ]
    plugins: ['counter', 'supersub']
    linkAnchor: false
    linebreaks: true

  $(".redactor-with-upload").redactor
    # placeholder: 'Leave your students with your closing thoughts or something to ponder.'
    imageUpload: "/redactor_images?" + params
    imageGetJson: "/redactor_images"
    path: "/assets/redactor"
    autoresize: false
    buttons: [
      "bold"
      "italic"
      "underline"
      "|"
      "link"
      "image"
    ]
    plugins: ['counter', 'supersub']
    linkAnchor: false
    linebreaks: true
    changeCallback: (html) ->
      $("form.edit_lesson").dirtyForms "setDirty"
      return

  return
